import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CollectionsService } from '../../../../../services/collections.service';
import { PaymentService } from '../../../../../services/payment.service';
import { JobcardService } from '../../../../../services/jobcard.service';
import moment from 'moment';
import Swal from 'sweetalert2';
import { AnimationStyleMetadata } from '@angular/animations';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-service-dropoff',
  templateUrl: './service-dropoff.component.html',
  styleUrls: ['./service-dropoff.component.scss'],
})
export class ServiceDropoffComponent implements OnInit {
  public deliveryDate: any;
  public address: any;
  public addressDetails: any;
  public name: string;
  public contactDetails: string;
  public dropOffInstructions: string;
  public partner: any;
  public addressOptions = [];
  public multiBikeDelivery: boolean = false;
  public linkedServices: any = [];

  public serviceID: any;
  public dropOffService: any;

  public distanceToPartner: number;

  public selectedService: any = { radius: 0 };

  public collectionTime: any;
  public invoice: any = {};

  public times: any = [];
  public availableDates: any = [];
  public confirmAddress: boolean = false;
  public addressConfirmed: boolean = false;
  public addressOutOfRange: boolean = false;
  public confirmingAddress: boolean = false;

  public googlePlaceID: string;
  public selectedTimeSlot: any;
  public deliveryFee: any;
  public areaID: number = 0;
  public vatInclusive: boolean = true;
  public currencySymbol: string = '';
  public jobCards: any = [];

  public minDate: any;
  disabledDates: any = [];
  errorDate: boolean;
  errorTime: boolean;
  errorName: boolean;
  errrorAddress: boolean;
  errorAddress: boolean;
  errorContactDetails: boolean;
  allReadyBooked: boolean;
  dropOffTime: any;
  dropOff: boolean;
  loading = false;
  loadingInvoice = false;
  saving = false;
  public jobCard: any = null;
  public rescheduleDelivery: boolean = false;
  public partnerID = "";
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    public collectionsService: CollectionsService,
    public jobcardService: JobcardService,
    public confirmationService: ConfirmationService,
    public paymentService: PaymentService,
  ) { }

  ngOnInit() {
    this.serviceID = this.route.snapshot.paramMap.get('serviceid');
    this.partnerID = this.route.snapshot.queryParamMap.get('Theme');
    //this.getInvoiceDetails();
    this.getDropOffDetails();


    const payment_intent =
      this.route.snapshot.queryParamMap.get('payment_intent');
    const redirect_status =
      this.route.snapshot.queryParamMap.get('redirect_status');
    const error = this.route.snapshot.queryParamMap.get('error');
    if (payment_intent && redirect_status) {
      this.loading = true;
      var pi_result = {
        paymentIntent: {
          id: payment_intent,
          status: redirect_status,
          error: error,
        },
      };
      this.completePayment(pi_result);
    }

    this.minDate = new Date();

    var startDate = new Date(
      moment(this.minDate).add('year', -1).format('YYYY-MM-DD'),
    );
    var endDate = new Date(
      moment(this.minDate).add('year', 2).format('YYYY-MM-DD'),
    );
    while (startDate <= endDate) {
      var d = new Date(startDate);
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
      this.disabledDates.push(d);
      startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    }
  }

  completePayment(pi_result) {
    // if (pi_result && pi_result.paymentIntent && pi_result.paymentIntent.status === 'succeeded') {
    //     this.router.navigateByUrl(this.router.url.indexOf("?") > -1 ? this.router.url.split("?")[0] : this.router.url);
    //     Swal.fire({
    //       title: 'Invoice Paid',
    //       text: 'Thank you for paying your invoice through Hubtiger.',
    //       icon: 'success',
    //       onClose: ()=>{
    //       }
    //     });
    // }
  }

  /*
  getInvoiceDetails() {
    this.loadingInvoice = true
    this.jobcardService.getFullJobCardsV1(this.serviceID, this.partnerID, "undefined").subscribe(
      (invoice) => {
        this.getDropOffDetails();
        //get the total bill, we only want to allow the Stripe payment if the bill is > 0
        var totalBill = invoice
          .map((x) => {
            return x.invoice.total;
          })
          .reduce((a, b) => a + b, 0);

        if (invoice && invoice.length > 0) {
          this.invoice = {
            allowStripePayment:
              invoice[0].invoice.allowStripePayment && totalBill > 0,
            paidWithStripe: invoice[0].invoice.paidWithStripe,
          };
        }

        this.loadingInvoice = false;
      },
      (err) => {
        this.loadingInvoice = false;
      },
    );
  }*/

  getDropOffDetails() {
    this.loading = true;
    this.collectionsService.getDropOffDetails(this.serviceID, this.partnerID).subscribe(
      (res) => {
        if (res && res.serviceID) {
          this.deliveryDate =
            res.deliveryInfo && res.deliveryInfo.scheduleDate
              ? new Date(res.deliveryInfo.scheduleDate)
              : null;
          this.dropOffTime = res.deliveryInfo && res.deliveryInfo.timeSlotLabel;
          this.allReadyBooked =
            res.deliveryInfo &&
            res.deliveryInfo.id &&
            res.deliveryInfo.scheduleDate &&
            res.deliveryInfo.deliveryVehicleID;
          this.address = {
            address: res.deliveryInfo
              ? res.deliveryInfo.fullAddress
              : res.collectionInfo
                ? res.collectionInfo.fullAddress
                : '',
          };
          this.dropOff = res.dropOff;
          this.dropOffInstructions = res.deliveryInfo && res.deliveryInfo.notes;
          this.contactDetails =
            (res.deliveryInfo && res.deliveryInfo.contactDetails) ||
            (res.collectionInfo && res.collectionInfo.contactDetails) ||
            res.phoneNumber;
          this.partner = {
            partnerID: res.partnerID,
            latitude: res.latitude,
            longitude: res.longitude,
          };
          this.multiBikeDelivery = res.hasLinkedServices;
          this.linkedServices = res.otherLinkedServices;

          if (this.address.address) {
            this.getLocationFromAddress(this.address.address);
          }

          var totalBill = res.jobCards
            .map((x) => {
              return x.invoice.total;
            })
            .reduce((a, b) => a + b, 0);

          if (res.jobCards && res.jobCards.length > 0) {
            this.invoice = {
              allowStripePayment:
                res.jobCards[0].invoice.allowStripePayment && totalBill > 0,
              paidWithStripe: res.jobCards[0].invoice.paidWithStripe,
            };
          }
          this.jobCards = res.jobCards;
        }

        this.loading = false;
      },
      (err) => {
        alert('There was a problem fetchig this delivery information');
      },
    );
  }

  selectTime(timeSlot, index) {
    this.selectedTimeSlot = timeSlot;
  }

  setBookingDate(reset = false) {
    this.times = [];
    if (this.deliveryDate) {
      if (reset) {
        this.selectedTimeSlot = null;
      }

      var selectedDate = this.availableDates.filter((x) => {
        return (
          moment(x.availableDate).format('YYYY-MM-DD') ===
          moment(this.deliveryDate).format('YYYY-MM-DD')
        );
      });
      if (selectedDate && selectedDate.length > 0) {
        this.times = selectedDate[0].slots.map((x, index) => {
          return { ...x, code: index + 1, name: x.label, value: x.label };
        });
        if (this.times.length == 1) {
          this.selectedTimeSlot = this.times[0];
        }
      }
    }
  }

  monthChanged(date) {
    this.times = [];
    var fromDate = moment(new Date(date.year, date.month - 1, 1))
      .startOf('month')
      .format('YYYY-MM-DD');
    this.getAvailability(fromDate);
  }

  getAvailability(fromDate: string, reset = true) {
    if (this.areaID) {
      const data = {
        PartnerID: this.partner.partnerID,
        FromDate: moment(fromDate).add('days', -7).format('YYYY-MM-DD'),
        ToDate: moment(fromDate)
          .add('month', 2)
          .endOf('month')
          .format('YYYY-MM-DD'),
        CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        IsCollection: false,
        IsDelivery: true,
        AreaID: this.areaID,
      };
      var invalidDates = JSON.parse(JSON.stringify(this.disabledDates));
      invalidDates = invalidDates.map((x) => {
        return new Date(x);
      });
      this.collectionsService.getCollectionsAvailability(data).subscribe(
        (response: any) => {
          if (response.availableDates && response.availableDates.length > 0) {
            this.availableDates = response.availableDates;
            response.availableDates.forEach((availableDate: any) => {
              var index = invalidDates
                .map((x) => {
                  return moment(x).format('YYYY-MM-DD');
                })
                .indexOf(
                  moment(availableDate.availableDate).format('YYYY-MM-DD'),
                );
              if (index > -1) {
                invalidDates.splice(index, 1);
              }
            });
            this.disabledDates = invalidDates;
            if (!reset) {
              this.setBookingDate(reset);
            }
          }
          if (
            response.unavailableDates &&
            response.unavailableDates.length > 0
          ) {
            response.unavailableDates.map((x) => {
              var d = new Date(x.unavailableDate);
              d.setHours(0);
              d.setMinutes(0);
              d.setSeconds(0);
              d.setMilliseconds(0);
              var index = this.disabledDates.findIndex((x) => {
                return x.valueOf() === d.valueOf();
              });
              if (index === -1) {
                this.disabledDates.push(d);
              }
            });
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
    } else {
      this.loading = false;
    }
  }

  PopUp() {
    Swal.fire(
      'Delivery Booked',
      'Your bike has been scheduled for delivery',
      'success',
    ).then((result) => {
      if (result.value) {
      }
    });
    this.getDropOffDetails();
  }

  Book() {
    this.errorTime = !this.selectedTimeSlot;
    this.errorDate = !this.deliveryDate;
    this.errorAddress = !this.address && !this.address.address;
    this.errorContactDetails = !this.contactDetails;

    if (
      !(
        this.errorTime ||
        this.errorDate ||
        this.errorAddress ||
        this.errorContactDetails
      )
    ) {
      this.errorDate = false;
      this.saving = true;

      const data = {
        ServiceID: this.serviceID,
        DeliveryVehicleID: this.selectedTimeSlot.deliveryVehicleID,
        ScheduleDate: moment(this.deliveryDate).format('YYYY-MM-DD'),
        ScheduleTimeSlotStart: this.selectedTimeSlot.slotStartTime,
        ScheduleTimeSlotEnd: this.selectedTimeSlot.slotEndTime,
        Notes: this.dropOffInstructions,
        ContactDetails: this.contactDetails,
        Address:
          this.address && this.address.address ? this.address.address : '',
        AddressDetails: this.addressDetails,
      };

      this.collectionsService.postDropOffInfo(data).subscribe(
        (res) => {
          this.PopUp();
          this.rescheduleDelivery = false;
          this.saving = false;
        },
        (err) => {
          this.saving = false;
        },
      );
    }
    console.log();
  }

  search(address) {
    this.areaID = 0;
    this.googlePlaceID = null;
    this.confirmAddress = false;
    this.addressConfirmed = false;
    this.selectedService = {};
    this.collectionsService
      .getAddressOptions(
        address.query,
        `${this.partner.latitude},${this.partner.longitude}`,
      )
      .subscribe((res) => {
        console.log(res);
        this.addressOptions = res.predictions.map((x) => {
          return { address: x.description, placeID: x.place_id };
        });
      });
  }

  async getAddressPlaceDetails(getLocationFromAddress = false) {
    var address =
      this.address.address.toLowerCase().indexOf('flat') > -1
        ? this.address.address.replace('flat', '').replace('Flat', '')
        : this.address.address; //The flat causes googles API to sometimes return no results so just removeing it from the query to avoid not results
    await this.collectionsService
      .getAddressOptions(
        address,
        `${this.partner.latitude},${this.partner.longitude}`,
      )
      .subscribe((res) => {
        this.googlePlaceID =
          res.predictions && res.predictions.length > 0
            ? res.predictions[0].place_id
            : 'No Place ID';
        if (getLocationFromAddress) {
          this.getLocationFromAddress(address);
        }
      });
  }

  setAddressInfo(placeInfo) {
    if (placeInfo) {
      var GooglePlace = JSON.parse(placeInfo).result;
      console.log(GooglePlace);
      var addressDetails = {
        street_no: null,
        street_address: null,
        city: null,
        country: null,
        postal_code: null,
        latitude: null,
        longitude: null,
      };
      if (GooglePlace && GooglePlace.address_components) {
        var street_no = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('street_number') > -1;
          })
          .pop();
        if (street_no) {
          addressDetails.street_no = street_no.long_name;
        }
        var street_address = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('route') > -1;
          })
          .pop();
        if (street_address) {
          addressDetails.street_address = street_address.long_name;
        }
        var city = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_town') > -1;
          })
          .pop();
        if (city) {
          addressDetails.city = city.long_name;
        }
        if (!city) {
          var city = GooglePlace.address_components
            .filter((x) => {
              return x.types.indexOf('locality') > -1;
            })
            .pop();
          if (city) {
            addressDetails.city = city.long_name;
          }
        }

        var country = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('country') > -1;
          })
          .pop();
        if (country) {
          addressDetails.country = country.long_name;
        }
        var postal_code = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_code') > -1;
          })
          .pop();
        if (postal_code) {
          addressDetails.postal_code = postal_code.long_name;
        }
        addressDetails.latitude = GooglePlace.geometry.location.lat;
        addressDetails.longitude = GooglePlace.geometry.location.lng;
        this.addressDetails = addressDetails;
      }
    }
  }

  getLocationFromAddress(address) {
    this.collectionsService
      .getLocationFromAddress(address)
      .subscribe(async (res) => {
        const data = {
          PartnerID: this.partner.partnerID,
          IsCollection: 0,
          IsDelivery: 1,
          Latitude: res.lat,
          Longitude: res.lng,
          CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        };
        if (!this.googlePlaceID) {
          this.getAddressPlaceDetails(true);
          return;
        }
        this.collectionsService.checkAddressInRange(data).subscribe(
          (addressInfo: any) => {
            console.log(addressInfo);
            console.log(this.partner.partnerID);
            if (
              addressInfo &&
              addressInfo.partnerID == this.partner.partnerID
            ) {
              this.collectionsService
                .getGooglePlaceInfo(this.googlePlaceID)
                .subscribe((placeInfo) => {
                  this.setAddressInfo(placeInfo);
                });
              this.addressOutOfRange = false;
              this.distanceToPartner = addressInfo.distanceToStore;
              this.deliveryFee = addressInfo.deliveryFee;
              this.areaID = addressInfo.areaID;
              this.vatInclusive = addressInfo.vatInclusive;
              this.currencySymbol = addressInfo.currencySymbol;

              var fromDate = moment(this.deliveryDate || this.minDate)
                .startOf('month')
                .format('YYYY-MM-DD');
              this.getAvailability(fromDate, false);
            } else {
              this.addressOutOfRange = true;
              this.distanceToPartner = -1;
              this.areaID = 0;
              this.deliveryFee = null;
            }
          },
          (err) => {
            this.addressOutOfRange = true;
            this.distanceToPartner = -1;
            this.areaID = 0;
            this.deliveryFee = null;
          },
        );
      });
  }

  recalculateDeliveryCost(event) {
    if (event && this.areaID) {
      this.confirmingAddress = true;
      const data = {
        AreaID: this.areaID,
        Address: this.address.address,
        AddressDetails: this.addressDetails,
      };
      this.collectionsService
        .updateDeliveryAddress(this.serviceID, data)
        .subscribe(
          (result) => {
            this.addressConfirmed = true;
            this.confirmingAddress = false;
          },
          (err) => {
            this.confirmingAddress = false;
          },
        );
    }
  }

  onSelect(event) {
    this.googlePlaceID = event.placeID;
    if (!event.placeID) {
      this.getAddressPlaceDetails(true);
    } else {
      this.getLocationFromAddress(event.address);
    }
  }

  cancelDropOff() {
    this.rescheduleDelivery = false;
    this.confirmationService.confirm({
      key: 'cancel_delivery',
      rejectLabel: 'No',
      acceptLabel: 'Cancel Delivery',
      header: 'Cancel Delivery',
      message:
        'Are you sure you would like to cancel delivery? Any delivery fees already paid cannot be reversed.',
      accept: () => {
        this.saving = true;
        this.collectionsService
          .cancelDropOff(this.serviceID)
          .subscribe((res) => {
            Swal.fire(
              'Delivery Cancelled',
              'Your bike will be waiting for you',
              'success',
            );
            this.getDropOffDetails();
            //this.getInvoiceDetails();
            this.saving = false;
          });
      },
    });
  }

  rescheduleDropOff() {
    this.rescheduleDelivery = true;
  }

  rescheduleCancelledDropOff() {
    this.dropOff = true;
    this.rescheduleDelivery = true;
    this.deliveryDate = null;
    this.selectedTimeSlot = null;
    this.times = [];
  }

  updateJobCard(jobcard) {
    console.log(jobcard);
    this.jobCard = jobcard;
  }

  reloadDelivery(jobcard) {
    this.jobCard = jobcard;
    this.getDropOffDetails();
    //this.getInvoiceDetails();
  }
}
